import React, { useState } from "react";

const NavTasks = () => {
  const [task, setTask] = useState(false);
  return (
    <>
      {/* <div className="alert-icon session-btn app_tooltip bottom  ar-new-task" onClick={() => setTask(!task)}>
        <span class="icon-Group-6357 fs-19"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span></span>
        <span className="count ">1</span>
        <p class="tool_tip xsm_text text-light">Task</p>
      </div>
      {task && (
        <>
          <div className="ar-CurSession__Tab ">
            <div className="d-flex justify-content-between align-items-center mb-10 px-10">
              <p className="heading">Task Notifications</p>
            </div>
            <div className="d-flex flex-column gap-10 px-10 scroll pb-2">
              <div className="ar-content">
                <div className="ar-header d-flex justify-content-between align-items-center">
                  <p className="text font-m d-flex gap-1 align-items-center pb-1">
                    Create Alert Popup <i className="icon-Vector-8 fs-10"></i>
                  </p>
                  <i className="fs-10 icon-Icon-metro-cross opacity-0"></i>
                </div>

                <p
                  className="fs-10 text validation_message text-nowrap pb-2"
                  title=""
                >
                  Pls do start work on alert popup changes that...
                </p>
                <div className="row m-0 g-0">
                  <div className="col-md-5">
                    <div className="d-flex align-items-center gap-1">
                      <span className="text fs-10 ar-light-color text-nowrap">
                        Due date :
                      </span>
                      <span className="text fs-11 fst-italic ar-light-color">
                        5/31/2024
                      </span>
                    </div>
                  </div>
                  <div className="col-md-7 ps-2">
                    <div className="d-flex align-items-center gap-1 ps-1">
                      <span className="text fs-10 ar-light-color text-nowrap">
                        Assign to :
                      </span>
                      <span
                        className="text fs-11 fst-italic ar-light-color text-nowrap validation_message"
                        title=""
                      >
                        Israh
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ar-content">
                <div className="ar-header d-flex justify-content-between align-items-center">
                  <p className="text font-m d-flex gap-1 align-items-center pb-1">
                    Create Alert Popup <i className="icon-Vector-8 fs-10"></i>
                  </p>
                  <i className="fs-10 icon-Icon-metro-cross opacity-0"></i>
                </div>

                <p
                  className="fs-10 text validation_message text-nowrap pb-2"
                  title=""
                >
                  Pls do start work on alert popup changes that...
                </p>
                <div className="row m-0 g-0">
                  <div className="col-md-5">
                    <div className="d-flex align-items-center gap-1">
                      <span className="text fs-10 ar-light-color text-nowrap">
                        Due date :
                      </span>
                      <span className="text fs-11 fst-italic ar-light-color">
                        5/31/2024
                      </span>
                    </div>
                  </div>
                  <div className="col-md-7 ps-2">
                    <div className="d-flex align-items-center gap-1 ps-1">
                      <span className="text fs-10 ar-light-color text-nowrap">
                        Assign to :
                      </span>
                      <span
                        className="text fs-11 fst-italic ar-light-color text-nowrap validation_message"
                        title=""
                      >
                        Israh
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ar-content">
                <div className="ar-header d-flex justify-content-between align-items-center">
                  <p className="text font-m d-flex gap-1 align-items-center pb-1">
                    Create Alert Popup <i className="icon-Vector-8 fs-10"></i>
                  </p>
                  <i className="fs-10 icon-Icon-metro-cross opacity-0"></i>
                </div>

                <p
                  className="fs-10 text validation_message text-nowrap pb-2"
                  title=""
                >
                  Pls do start work on alert popup changes that...
                </p>
                <div className="row m-0 g-0">
                  <div className="col-md-5">
                    <div className="d-flex align-items-center gap-1">
                      <span className="text fs-10 ar-light-color text-nowrap">
                        Due date :
                      </span>
                      <span className="text fs-11 fst-italic ar-light-color">
                        5/31/2024
                      </span>
                    </div>
                  </div>
                  <div className="col-md-7 ps-2">
                    <div className="d-flex align-items-center gap-1 ps-1">
                      <span className="text fs-10 ar-light-color text-nowrap">
                        Assign to :
                      </span>
                      <span
                        className="text fs-11 fst-italic ar-light-color text-nowrap validation_message"
                        title=""
                      >
                        Israh
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="px-10 d-flex align-items-center justify-content-end ar-footer gap-1">
              <i className="bi bi-check-all fs-18"></i>
              <p className="text fs-11 cursor-pointer">Mark all as read</p>
            </div>
          </div>
        </>
      )} */}
    </>
  );
};

export default NavTasks;
